export const removeLocalStorageItem = key => localStorage.removeItem(key);

export const getLocalStorageItem = key => {
  try {
    return localStorage.getItem(key);
  } catch (err) {
    return removeLocalStorageItem(key);
  }
};

export const getLocalStorageObject = key => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (err) {
    return removeLocalStorageItem(key);
  }
};

export const persistStringToLocalStorage = (key, value) =>
  localStorage.setItem(key, value);

export const persistObjectToLocalStorage = (key, value) =>
  localStorage.setItem(key, JSON.stringify(value));
